import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React, { Fragment } from "react";
import { config, initialState } from "./config";

class WorkRestInfo extends PanelTemplate {
    renderBody = () => {
        const { editable, config } = this.props;
        const {
            averageSpeed,
            workHours,
            maxLoadUnloadPeriod,
            emptyMileagePointStayPeriod,
            maxPlannedBidsCount,
            dayStart,
            matchingDistributionBidsRadius,
            recommendedBreakTime,
            recommendedRestTime,
            recommendedWorkTime,
            doNotSendDriverNotificationsOffHours,
            useLastCarLocationForEmptyMileageBid,
        } = config;
        return (
            <Fragment>
                {this.renderField({ ...averageSpeed, disabled: !editable })}
                {this.renderField({ ...workHours, disabled: !editable })}
                {this.renderField({ ...maxPlannedBidsCount, disabled: !editable })}
                {this.renderField({ ...maxLoadUnloadPeriod, disabled: !editable })}
                {this.renderField({ ...emptyMileagePointStayPeriod, disabled: !editable })}
                {this.renderField({ ...dayStart, disabled: !editable })}
                {this.renderField({ ...matchingDistributionBidsRadius, disabled: !editable })}
                {this.renderField({ ...recommendedBreakTime, disabled: !editable })}
                {this.renderField({ ...recommendedRestTime, disabled: !editable })}
                {this.renderField({ ...recommendedWorkTime, disabled: !editable })}
                {this.renderCheckbox({ ...doNotSendDriverNotificationsOffHours, disabled: !editable })}
                {this.renderCheckbox({ ...useLastCarLocationForEmptyMileageBid, disabled: !editable })}
            </Fragment>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки труда и отдыха</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const normalizeData = (data) => ({
    ...data,
    emptyMileagePointStayPeriod: data.emptyMileagePointStayPeriod ? `${data.emptyMileagePointStayPeriod}:00` : null,
});

const ConfiguredPanel = (props) => (
    <WorkRestInfo
        {...props}
        action={(data) => props.action(normalizeData(data))}
        config={config}
        initialState={initialState}
    />
);

export default ConfiguredPanel;
